import { createSelector } from '@reduxjs/toolkit';
import { selectFromDeveloper } from 'shared/selectors/jsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'От застройщиков', value: true },
  { label: 'От агентов и частных лиц', value: false },
];

export const selectOfferTypeFilter = createSelector(selectFromDeveloper, value => ({
  label: 'Тип объявления',
  value: [value],
  options: OPTIONS,
}));
